import { useEffect } from 'react';
import details from 'assets/Details';

const SITE_URL = details.contact.website;

function injectJsonLd() {
  const person = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: `${details.name.first} ${details.name.last}`,
    alternateName: details.name.nickname,
    url: SITE_URL,
    jobTitle: details.experience[0]?.position ?? 'Full Stack Engineer',
    worksFor: details.experience[0] ? {
      '@type': 'Organization',
      name: details.experience[0].company,
      url: details.experience[0].url,
    } : undefined,
    email: details.contact.email,
    address: {
      '@type': 'PostalAddress',
      addressLocality: details.contact.address,
    },
    sameAs: [
      details.contact.linkedin,
      details.contact.github,
      details.contact.researchgate,
      details.contact.gitlab,
    ].filter(Boolean),
  };

  const website = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: `${details.name.first} ${details.name.last} - Portfolio`,
    url: SITE_URL,
    description: 'Portfolio and resume of a full-stack engineer. Projects, experience, and contact.',
    author: {
      '@type': 'Person',
      name: `${details.name.first} ${details.name.last}`,
    },
    potentialAction: {
      '@type': 'ReadAction',
      target: [SITE_URL, `${SITE_URL}/resume`, `${SITE_URL}/projects`],
    },
  };

  const existing = document.querySelectorAll('script[type="application/ld+json"]');
  existing.forEach((el) => el.remove());

  [person, website].forEach((data) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
  });
}

export default function JsonLd() {
  useEffect(() => {
    injectJsonLd();
  }, []);
  return null;
}
